import { Small, Flex, Tag } from "orcs-design-system";

type GroupLabelOption = {
  label: string;
  value: string;
  valueKey?: string;
  [key: string]: unknown;
};

const formatGroupLabel = (
  option: GroupLabelOption,
  onSelect: (valueKey: string | undefined, value: unknown) => void
) => {
  const selectedValue = {
    ...option,
    label: "Any",
    optionalLabel: `${option.label} tag`,
  };
  return (
    <Flex
      p="6px"
      alignItems="flex-start"
      flexDirection="column"
      flexWrap="wrap"
      onClick={() => onSelect(option.valueKey, selectedValue)}
      gap="xs"
    >
      <Small color="subText">Filter for people with:</Small>
      <Tag tagType={`${option.label} tag`} small>
        Any
      </Tag>
    </Flex>
  );
};

export default formatGroupLabel;
